(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadParameter', LeadParameter);

    LeadParameter.$inject = ['$resource'];

    function LeadParameter ($resource) {
        var resourceUrl =  'api/lead-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
